import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AutocompleteProductsQuery } from "../graphql/queries";
import type {
  AutocompleteProductsQueryType,
  AutocompleteProductsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAutocompleteProductsQuery = (
  options?: QueryHookOptions<
    AutocompleteProductsQueryType,
    AutocompleteProductsQueryVariablesType
  >
) => {
  return useQuery<
    AutocompleteProductsQueryType,
    AutocompleteProductsQueryVariablesType
  >(AutocompleteProductsQuery, options);
};
